import React from 'react'
import { connect } from 'react-redux'
import { styled } from '@mui/material/styles'
import { Box, Button, TableBody, TableCell, TableRow, Typography } from '@mui/material'
import { LockOutlined } from '@mui/icons-material'
import classNames from 'classnames'
import { rxEnterRoom } from '../lib/rx_subject'

const RoomTableRow = styled(TableRow)(
  ({ theme }) => `
  &.empty {
    background-color: ${theme.palette.lightBack.primary};

    .num-users {
      color: ${theme.palette.text.secondary};
    }
  }
`
)

const RoomRow = ({ room }) => {
  const enterRoom = room => {
    rxEnterRoom.next(room)
  }

  const empty = room.numUsers === 0

  return (
    <RoomTableRow className={classNames({ empty })}>
      <TableCell className="enter-room">
        <Button variant="outlined" color="primary"
                className="enter-room-button"
                onClick={() => enterRoom(room)}>
          入室
        </Button>
      </TableCell>
      <TableCell className="room-name">
        <Typography variant="body2">Room{room.no}</Typography>
      </TableCell>
      <TableCell className="num-users">
        <Typography variant="body2">{empty ? '-' : room.numUsers}</Typography>
      </TableCell>
      <TableCell className="room-title">
        <Box className="content">
          {room.hasPassword && <LockOutlined fontSize="small" className="has-password" />}
          <Typography variant="body2">{room.title}</Typography>
        </Box>
      </TableCell>
    </RoomTableRow>
  )
}

const RoomsBody = ({ rooms }) => {
  return (
    <TableBody>
      {rooms.map(room => <RoomRow key={room.no} room={room} />)}
    </TableBody>
  )
}

export default connect(
  state => ({
    rooms: state.rooms
  })
)(RoomsBody)
